module.exports = __webpack_public_path__ + "img/2255342-28-8.4f2abe30.png";